/**
 * Wallpaper Visualizer launcher — EazzyWalls
 *
 * Opens the Wizart visualizer full screen via the official WizartDeploymentKit
 * SDK. The visualizer instance is created on first click only, so nothing is
 * requested during page load.
 *
 * Triggers: any .wizart-launch element, inside <wizart-visualizer> or in rich text.
 */

const WIZART_TOKEN = 'NhTZMk3kdM2wv1pJpMm0sKSdXZHophf1Tp5Udr8bmCkV5kqpp0Bx8Shp0vdX';

let visualizer = null;
let isLoading = false;

/* The SDK script is deferred, so it may not be parsed when a click lands. */
function waitForSdk(timeout = 10000) {
  if (typeof WizartDeploymentKit !== 'undefined') return Promise.resolve();

  return new Promise((resolve, reject) => {
    const started = Date.now();
    const poll = setInterval(() => {
      if (typeof WizartDeploymentKit !== 'undefined') {
        clearInterval(poll);
        resolve();
      } else if (Date.now() - started > timeout) {
        clearInterval(poll);
        reject(new Error('WizartDeploymentKit did not load'));
      }
    }, 100);
  });
}

async function openVisualizer(trigger) {
  if (isLoading) return;

  try {
    isLoading = true;
    if (trigger) trigger.setAttribute('aria-busy', 'true');

    await waitForSdk();

    if (!visualizer) {
      visualizer = new WizartDeploymentKit.Visualizer({
        token: WIZART_TOKEN,
        layoutSettings: {
          targetElement: document.body.firstChild,
          layout: WizartDeploymentKit.LAYOUTS.FULL_SCREEN,
          position: WizartDeploymentKit.POSITIONS.BEFORE
        }
      });
    }

    visualizer.show();
  } catch (error) {
    console.warn('Visualizer failed to load', error);
  } finally {
    isLoading = false;
    if (trigger) trigger.removeAttribute('aria-busy');
  }
}

/* Semantic wrapper only. Registration is defensive — ALL click handling happens
   in the single delegated listener below, so the launcher still works even if
   this element name is ever claimed by another script. */
class WizartVisualizer extends HTMLElement {}

if (!customElements.get('wizart-visualizer')) {
  customElements.define('wizart-visualizer', WizartVisualizer);
}

/* One listener for every trigger on the page — section buttons and buttons
   pasted into the page Content field alike. Cannot double-fire. */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('.wizart-launch');
  if (!trigger) return;
  event.preventDefault();
  openVisualizer(trigger);
});